export const time = (ms: number = 0) => new Promise(resolve => setTimeout(resolve, ms))
